import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { expandTermsAndConditions } from '../../store/actions'
import { bindActionCreators } from 'redux'
import loadable from '@loadable/component'
import { getCategoryUKGC, getUKGCLink } from './tools'

const Hypertext = loadable(() => import('@albatross/common-components/dist/components/Hypertext'))

const UKGCContainer = (props) => {
  const {
    game,
    maxWidth,
    background,
    customUKGC,
    expandTermsAndConditions,
    globalContent,
    venture,
    customUKGCLink,
    enableContentful
  } = props
  useEffect(() => {
    expandTermsAndConditions()
  }, [])

  const setBackground = background || game?.backgroundColour
  const categoryUKGC = enableContentful
    ? game?.customUKGCText
    : getCategoryUKGC(
      game?.categoryId,
      globalContent?.categories
    )
  const UKGCLink = customUKGCLink || game?.customUKGCLink || getUKGCLink(game?.categoryId, globalContent?.categories)

  return (
      <Hypertext
        expandTermsAndConditions={expandTermsAndConditions}
        welcomeBonusTermsAndConditionsShort={
          categoryUKGC ||
          customUKGC ||
          globalContent.welcomeBonusTermsAndConditionsShort
        }
        maxWidth={maxWidth}
        background={setBackground}
        venture={venture}
        customUKGCLink={UKGCLink}
        enableContentful={enableContentful}
      />
  )
}

UKGCContainer.propTypes = {
  game: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array]),
  maxWidth: PropTypes.string,
  background: PropTypes.string,
  customUKGC: PropTypes.string,
  expandTermsAndConditions: PropTypes.func,
  globalContent: PropTypes.object,
  venture: PropTypes.string,
  customUKGCLink: PropTypes.string,
  enableContentful: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    termsAndConditionsOpen: state.termsAndConditionsOpen
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ expandTermsAndConditions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UKGCContainer)
